import { useApi } from './api';

export const usePlayersStats = (season) =>
  useApi(`statistics/players/${season}`);
